import { configureStore } from '@reduxjs/toolkit';
import isDropdownMenuOpenReducer from './isDropdownMenuOpenSlice';

export default configureStore({
	reducer: {
		isDropdownMenuOpen: isDropdownMenuOpenReducer,
	},
});
